module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-02-29 at 6.26.12 PM.b737bcbe.jpeg";